import React from 'react';
import './App.css';
import Counter from './Counter';

function App() {
  return (
    <div className="App">
     <Counter/>
    </div>
  );
}

export default App;
